import React, { useCallback } from 'react';
import LoadedDataTable from '../../../../Elements/DataTable/LoadedDataTable';
import AnnouncementBanner from '../../../../Elements/AnnouncementBanner';
import InvoiceAutomationService from '../../../../Services/InvoiceAutomationService';
import InvoiceAutomationExcludedJobItem from '../../../../Domain/ThirdParty/Project/InvoiceAutomationExcludedJobItem';

// The jobs taken off the project's automatic invoicing drafts, out of scope for the automation from then on, under a
// banner that says how to invoice them: brought back in with Run Now, or added by hand.
export default function InvoiceAutomationExcludedJobList({ projectId = null }) {
  const loadExcludedJobs = useCallback(
    () => InvoiceAutomationService.GetInvoiceAutomationExcludedJobs(projectId),
    [projectId]
  );

  return (
    <>
      <AnnouncementBanner
        title='Bravo does not add these jobs again by itself'
        className='mb-3'
      >
        No run puts a job taken off an automatic draft back on a draft by itself. To invoice it, bring it back in with
        Run Now, or add it by hand from the project's Ready for Invoicing list, with Add To Invoice or Generate Invoice.
      </AnnouncementBanner>
      <LoadedDataTable
        load={loadExcludedJobs}
        failureMessage='Error! ErrorCode: IAEJL16. Failed to load the jobs taken off the drafts.'
        type={InvoiceAutomationExcludedJobItem}
        emptyMessage='No job has been taken off the automatic invoicing drafts.'
      />
    </>
  );
}
